var exports = {
  "M": "x61f99309--bbca0b--menu",
  "A": "x61f99309--bbca0b--item",
};

module.exports = exports;
